import { Injectable } from '@angular/core';
import { Budget } from 'src/app/models/budget.model';
import { AngularFirestore } from '@angular/fire/firestore';
import 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class BudgetService {

  constructor(private firestore: AngularFirestore) { }

  createBudget(budget: any){
    return this.firestore.collection('budgets').add({...budget});
  }

  getBudgets() {
    return this.firestore.collection('budgets').snapshotChanges();
  }

  updatePolicy(budget: Budget){
    delete budget.id;
    this.firestore.doc('budgets/' + budget.id).update(budget);
  }

  public updateBudget(budget){
    const id = budget.id;
    delete budget.id;
    return this.firestore.doc('budgets/'+id).update({...budget});
  }

  public deletebudget(id){
    return this.firestore.collection('budgets').doc(id).delete();
  }

}
